(function() {
  'use strict';

  angular.module('blocks.stores', []);
})();
